<div class="form-container">
    <div class="form-header">Start Your Free Trial</div>
    <div class="form-subheader">Beat your competitors with the most comprehensive, accurate dataset no one else has.</div>
    <div class="form-no-payment-required">No credit card required</div>
    <div class="form-content">
        <div class="form-row personal-details">
            <div class="form-input">
                <input
                    type="text"
                    placeholder="First Name"
                    autocomplete="given-name"
                    [formControl]="firstNameControl"
                    [class.error]="firstNameControl.invalid && firstNameControl.touched"
                    (keydown.enter)="onSubmit()">
                <div class="error-message" *ngIf="firstNameControl.invalid && firstNameControl.touched">
                    First Name is required
                </div>
            </div>
            <div class="form-input">
                <input
                    type="text"
                    placeholder="Last Name"
                    autocomplete="family-name"
                    [formControl]="lastNameControl"
                    [class.error]="lastNameControl.invalid && lastNameControl.touched"
                    (keydown.enter)="onSubmit()">
                <div class="error-message" *ngIf="lastNameControl.invalid && lastNameControl.touched">
                    Last Name is required
                </div>
            </div>
        </div>
        <div class="form-row email">
            <div class="form-input">
                <input
                    type="email"
                    placeholder="Work Email"
                    autocomplete="email"
                    [formControl]="emailControl"
                    [class.error]="emailControl.invalid && emailControl.touched"
                    (keydown.enter)="onSubmit()">
                <div class="error-message" *ngIf="emailControl.invalid && emailControl.touched">
                    {{ getEmailErrorMessage() }}
                </div>
            </div>
        </div>
        <button type="button" 
                class="submit-button" 
                [class.loading]="isLoading"
                [class.disabled]="isLoading"
                [disabled]="isLoading"
                (click)="onSubmit()">
            <span *ngIf="!isLoading">Get started for FREE</span>
            <span *ngIf="isLoading">Loading...</span>
        </button>
    </div>
</div>
<div class="legal-info">That legal sentence stating something about marketing emails and terms and stuff</div>
<div class="login-link">Already have an account?
    <a href="/polaris" (click)="sendPostHogLoginLinkEvent()">Log In</a>
</div>

